/** 首页轮播（原图在 src/assets/carousel，经 /api/carousel/ 访问） */
export const CAROUSEL_FILES = [
  "photo01.jpg",
  "photo15.jpg",
  "photo16.jpg",
  "photo17.jpg",
  "photo18.jpg",
  "photo12.jpg",
  "photo07.jpg",
  "photo19.jpg",
  "photo09.jpg",
] as const;

export function carouselRelativePath(filename: string): string {
  return `carousel/${filename}`;
}
